import styled from "@emotion/styled";

export default styled.div`
    ${props => props.theme.typography.body2};
    margin-bottom: 1rem;
    `